import template from './hero.html';

export default {
  restrict: 'E',
  controllerAs: 'vm',
  bindings: {
    title: '@heroTitle',
    lead: '@heroLead',
    image: '<heroImage'
  },
  template
};
